<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import InviteStepDate from "./dates/InviteStepDate.vue";
import InviteModalFooter from "~/components/Pages/training-plan/session-sidemodal/status-modal/InviteModalFooter.vue";
import { useCookieSessions } from "~/composables/sessions/useCookieSessions";
import { useSessionsStore } from "~/store/sessions/sessions-store";
import { useSessionDetailsStore } from "~/store/sessions/session-details-store";
import { usePagination } from "~/composables/paginations/usePagination";
import { useNotificationsStore } from "~/store/notifications/notifications.store";
import { useAuthStore } from "~/store/auth/auth.store";
import { RolesEnums } from "~/utils/enums/roles.enums";
import { useSessionDetailsAttendeesStore } from "~/store/sessions/session-details-attendees-store";
import { TimezoneDisplayModeEnum } from "~/utils/enums/timezones.enums";

const props = defineProps({
  /** Passed to `InviteStepDate`: READER from Mon activité, STEP from the admin status modal. */
  timezoneMode: {
    type: String as PropType<TimezoneDisplayModeEnum>,
    default: TimezoneDisplayModeEnum.STEP,
  },
});

const showDone: Ref<boolean> = ref(false);
const onLoaded: Ref<boolean> = ref(false);
const useCookie = useCookieSessions();
const emit = defineEmits(["hide", "notifConfirmModal"]);
const useSessions = useSessionsStore();
const useSessionDetails = useSessionDetailsStore();
const usePaginate = usePagination();
const useAuth = useAuthStore();
const sessionsStore = useSessionsStore();
const sessionDetailsAttendeesStore = useSessionDetailsAttendeesStore();
const { user } = storeToRefs(useAuth);

const { trainingPlanSessionIndividual } = storeToRefs(useSessions);

function hideModal() {
  showDone.value = false;
  sessionsStore.errorConfirmProject = false;
  emit("hide");
}
function loaded() {
  onLoaded.value = !onLoaded.value;
}

async function doneModal() {
  if (useCookie.getCookieSession("done_modal")) {
    if (trainingPlanSessionIndividual.value) {
      const id = trainingPlanSessionIndividual.value.id;

      await useSessions.fetchTrainingPlanSession(id);
      if (!useSessionDetails.sessionViewModal) {
        await usePaginate.fetchData();
      } else {
        await useSessionDetails.fetchSessionDetails(
          useSessionDetails.sessionDetails?.sessionId!,
          useSessionDetails.sessionDetails?.itemType!,
        );
        await sessionDetailsAttendeesStore.fetchSessionAttendeesFullDatas(
          useSessionDetails.sessionDetails?.sessionId!,
          useSessionDetails.sessionDetails?.itemType!,
        );
      }
    }
  } else {
    showDone.value = !showDone.value;
  }
  if (
    user.value?.roles.find(
      (u) => u.name === (RolesEnums.COMPANY_ADMIN || RolesEnums.GROUP_ADMIN || RolesEnums.TRAINING_ADMIN),
    )
  ) {
    emit("notifConfirmModal");
  }
}
</script>

<template>
  <CenterModal
    v-show="!showDone && onLoaded"
    :data-responsive="true"
    style="max-width: 720px; max-height: 772px; width: 100%; height: 100%"
    @hide="hideModal"
  >
    <template #body>
      <div class="flex flex-col h-full">
        <HeaderDetails :with-shadow="false" back-icon="arrow_left" :close="false" back @backClick="hideModal">
        </HeaderDetails>
        <div class="flex gap-[8px] overflow-auto body_regular w-full overflow-y-scroll">
          <InviteStepDate
            split-dropdown
            :timezone-mode="props.timezoneMode"
            @loaded="loaded"
            @hide="hideModal"
          ></InviteStepDate>
        </div>
        <InviteModalFooter @showDoneModal="doneModal" @hide="hideModal"></InviteModalFooter>
      </div>
    </template>
  </CenterModal>
  <!-- <InviteModalDone v-if="showDone" @hide="hideModal"></InviteModalDone> -->
</template>

<style scoped lang="scss">
.text-area {
  @apply min-h-[80px];
}

.svg_button__button {
  @apply w-[24px] h-[24px];
  color: var(--text-secondary-color);
  cursor: pointer;
}
</style>
